import { Field } from "formik";
import React, { useState, useContext, useEffect } from "react";
import { Accordion, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next"; /* Added Line */
import MultiSelect from "../../components/form-fields/MultiSelect";
import ReactDatePicker from "../../components/form-fields/ReactDatePicker";
import Select from "../../components/form-fields/Select";
import TextInput from "../../components/form-fields/TextInput";
import Filters from "../../components/list/Filters";
import ListComponent from "../../components/list/ListComponent";
import Main from "../../components/main/Main";
import { formatShortDate, formatListWithParameter, truncateText, formatFileTypeList } from "../../utils";
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  pushToParams,
} from "../../components/action-buttons/ActionButtonGenerator";
import request from "../../services/request";
import { ThemeContext } from '../../../context/ThemeContext';
import Checkbox from "../../components/form-fields/Checkbox";

function OtherReports() {
  const { changeSpinnerStatus } = useContext(ThemeContext);
  const [configData, setConfigData] = useState(null);
  const [activeIndicatorInLeftPosition, setActiveIndicatorInLeftPosition] =
    useState("");
  const [t] = useTranslation();
  const [refreshList, setRefreshList] = useState(false);
  const [filters, setFilters] = useState([]);
  const [talepTurleri, setTalepTurleri] = useState([]);
  const [dosyaTurleri, setDosyaTurleri] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [closedStartDate, setClosedStartDate] = useState(null);
  const [closedEndDate, setClosedEndDate] = useState(null);
  const [columns, setColumns] = useState([
    {
      dataField: "id",
      text: `${t("demandList.islemNo")}`,
      sort: true,
      filterId: 0,
      headerStyle: {
        width: 64
      },
      exportField: "id"
    },
    {
      dataField: "dosya.dosyaNo",
      text: t("demandCreate.dosyaNo"),
      sort: true,
      filterId: 1,
      headerStyle: {
        width: 64
      },
      exportField: "dosyaNo"
    },
    // {
    //   dataField: "talepDurumId",
    //   text: t("report.talepDurumuId"),
    //   sort: true,
    //   filterId: 2,
    // },
    // {
    //   dataField: "companyGroup",
    //   text: `${t("demandList.grup")}`,
    //   formatter: (data) => formatListWithParameter(data, "name"),
    //   sort: true,
    //   filterId: 3,
    // },
    {
      dataField: "company.name",
      text: `${t("demandList.grupSirketi")}`,
      formatter: (data) => truncateText(data, 25, 20),
      sort: true,
      filterId: 4,
      exportField: "company"
    },
    {
      dataField: "dosyaDurum.dosyaDurum",
      text: `${t("demandList.dosyaDurumu")}`,
      sort: true,
      filterId: 30,
      exportField: "dosyaDurum"
    },
    {
      dataField: "ilgiliSirketName",
      text: `${t("demandList.ilgiliSirket")}`,
      sort: true,
      filterId: 30,
      exportField: "ilgiliSirket"
    },
    {
      dataField: "talepTur.talepTuru",
      text: t("demandTypes.talepTürü"),
      sort: true,
      filterId: 5,
      exportField: "talepTur"
    },
    {
      dataField: "talepDurum.talepDurumName",
      text: t("demandStates.talepDurumu"),
      sort: true,
      filterId: 6,
      exportField: "talepDurum"
    },
    {
      dataField: "dosyaTuruList",
      text: t("demandUpdate.dosyaTuru"),
      formatter: (data) => formatFileTypeList(data, "dosyaTuru"),
      sort: true,
      filterId: 20,
      exportField: "dosyaTur"
    },
    {
      dataField: "talepTur.departman.name",
      text: t("documentTypes.departman"),
      sort: true,
      filterId: 7,
      exportField: "departman"
    },
    {
      dataField: "gnlTpDavaTuru.name",
      text: `${t("demandList.davaTuru")}`,
      sort: true,
      exportField: "davaTuru"
    },
    {
      dataField: "gnlTpIlkDavaTuru.name",
      text: `${t("demandList.davaTuru1")}`,
      sort: true,
      exportField: "ilkDavaTur"
    },
    {
      dataField: "gnlTpIkinciDavaTuru.name",
      text: `${t("demandList.davaTuru2")}`,
      exportField: "ikinciDavaTur"
    },
    {
      dataField: "gnlTpDil.name",
      text: `${t("demandList.dil")}`,
      sort: true,
      filterId: 8,
      exportField: "dil"
    },
    {
      dataField: "konu",
      text: `${t("demandList.konu")}`,
      formatter: (data) => truncateText(data, 35, 30),
      sort: true,
      filterId: 9,
      exportField: "konu"
    },
    {
      dataField: "cdate",
      text: t("demandList.talepTarihi"),
      sort: true,
      formatter: formatShortDate,
      filterId: 10,
      headerStyle: {
        width: 80
      },
      exportField: "talepTarih"
    },
    {
      dataField: "talepKapanisTarihi",
      text: t("report.kapanmaTarihi"),
      sort: true,
      formatter: formatShortDate,
      filterId: 11,
      exportField: "kapanmaTarihi"
    },
    {
      dataField: "avukat.fullName",
      text: `${t("demandList.avukat")}`,
      sort: true,
      filterId: 12,
      exportField: "avukat"
    },
    {
      dataField: "gorevlendirilenDisAvukat.fullName",
      text: t("demandUpdate.gorevlendirilenDisAvukat"),
      sort: true,
      filterId: 13,
      exportField: "gorevlendirilmisDisAvukatlar"
    },
    // {
    //   dataField: "toplamSure",
    //   text: t("report.kapanmaTarihi"),
    //   sort: true,
    //   filterId: 14,
    // },
    // {
    //   dataField: "dosyaTur.ucret",
    //   text: `${t("documentTypes.ücret")}`,
    //   sort: true,
    //   filterId: 15,
    // },
    {
      dataField: "bedel",
      text: `${t("demandList.bedel")}`,
      sort: true,
      filterId: 16,
      exportField: "bedel"
    },
    {
      dataField: "isGucuBirimi",
      text: t("report.isGucuBirim"),
      formatter: (data, row) => (row.isGucuBirimi ? row.isGucuBirimiName : ""),
      sort: true,
      filterId: 17,
      exportField: "isGucuBirimi"
    },
/*     {
      dataField: "sonDurum.mesaj",
      text: t("report.sonDurum"),
      formatter: (data) => truncateText(data, 35, 30),
      sort: true,
      filterId: 18,
      headerStyle: {
        width: 120
      }
    }, */
/*     {
      dataField: "sonDurum.userDto.fullName",
      text: t("report.sonDurumEkleyen"),
      sort: true,
      filterId: 19,
    }, */
    // {
    //   dataField: "taraf1",
    //   text: t("demandUpdate.taraf"),
    //   sort: true,
    //   filterId: 20,
    // },
    // {
    //   dataField: "dosyaNo",
    //   text: "Şirket İçi Yetkili Kullanıcı ID",
    //   sort: true,
    // },
  ]);
  const [companies, setCompanies] = useState([]);

  const onGroupChanged = (groupIds) => {
    getCompanies(groupIds);
  };

  const [resetButtonHandler, setResetButtonHandler] = useState(null);
  const [filteredColumns, _setFilteredColumns] = useState(columns);
  const setFilteredColumns = (filteredColumns) => {
    if(filteredColumns.length !== 0) {
      _setFilteredColumns(columns.filter((column) => filteredColumns.includes(column.exportField)));
    } else {
      _setFilteredColumns(columns);
    }
  };

  useEffect(() => {
    if (resetButtonHandler !== null) {
      _setFilteredColumns(columns);
    }
  }, [resetButtonHandler])
  

  const getCompanies = (companyGroupIds, yurtBilgi) => {
    request({
      url: "company/multi-company",
      method: "POST",
      data: {
        body: {
          companyGroupIds: [companyGroupIds],
        },
      },
    }, changeSpinnerStatus).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        setCompanies(response.body.tableData);
      }
    });
  };

  const onDepartmentChanged = (departmanId) => {
    request({
      url: "dosya-durum/config",
      method: "POST",
      data: {
        body: {
          id: departmanId,
        },
      },
    }, changeSpinnerStatus).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        setTalepTurleri(response.body.talepTur);
      }
    });
  };

  const onTalepChanged = (talepId) => {
    request({
      url: "dosya-tur/multi-talepTur-config-dosyaTur",
      method: "POST",
      data: {
        body: {
          companyGroupIds: talepId ? [talepId]: [],
        },
      },
    }, changeSpinnerStatus).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        setDosyaTurleri(response.body.tableData);
      }
    });
  };


  const getFilters = () => {
    const f = [...filters];

    f.forEach(filter => {
      if (filter.fieldName === 'fields') {
        filter.value = filteredColumns.map(c => c.exportField);
      }
    });

    if (f.length == 0) {
      f.push({
        fieldName: 'fields',
        value: filteredColumns.map(c => c.exportField),
        oper: "CONTAINS",
        joinEntity: null,
        type: null
      });
    }

    return f;
  }


  return (
    <Main>
      <div className="row">
        <div className="col-md-12">
          <Accordion
            className="accordion accordion-rounded-stylish accordion-bordered"
            defaultActiveKey="0"
          >
            <div className="accordion__item" key={"filter"}>
              <Accordion.Toggle
                as={Card.Text}
                eventKey={"filter"}
                className={`accordion__header ${
                  activeIndicatorInLeftPosition === "filter" ? "" : "collapsed"
                } accordion__header--primary`}
                onClick={() =>
                  setActiveIndicatorInLeftPosition(
                    activeIndicatorInLeftPosition === "filter" ? "" : "filter"
                  )
                }
              >
                <span className="accordion__header--icon"></span>
                <span className="accordion__header--text">
                  {t("sozlesmeler.filtreleme")}
                </span>
                <span className="accordion__header--indicator"></span>
              </Accordion.Toggle>
              <Accordion.Collapse
                eventKey={"filter"}
                className="accordion__body"
              >
                <div className="accordion__body--text">
                  <Filters
                    configPointUrl="raporlar/config"
                    setConfigData={(data) => setConfigData(data)}
                    setRefreshList={setRefreshList}
                    refreshList={refreshList}
                    setFilters={setFilters}
                    resetButtonHandler={resetButtonHandler}
                    setResetButtonHandler={setResetButtonHandler}
                    ignoreInitialDates
                  >
                    <Field
                        name="yurtici"
                        label={t("demandList.yurtici")}
                        colNumber="3"
                        component={Select}
                        placeholder={t("formFields.allPlaceHolder")}
                        options={configData && configData.yurtici}
                    />
                    <Field
                        name="sirketDurumu"
                        label={t("demandList.sirketDurumu")}
                        colNumber="3"
                        component={Select}
                        placeholder={t("formFields.allPlaceHolder")}
                        options={configData && configData.sirketDurumu}
                    />
                    <Field
                        name="isSubsidiary"
                        label={t("demandList.istirakSirketleri")}
                        colNumber="3"
                        component={Select}
                        placeholder={t("formFields.allPlaceHolder")}
                        options={configData && configData.isSubsidiary}
                    />
                    <Field
                      name="groupID"
                      label={t("davaIcraSavcilik.grup")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.grupSirketleri}
                      onChangeFunc={(opt) => onGroupChanged(opt)}
                    />
                    <Field
                      name="sirketID"
                      label={t("davaIcraSavcilik.grupSirketi")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={
                        companies.length > 0
                          ? companies.map((c) => {
                              return { value: c.id, label: c.name };
                            })
                          : configData && configData.sirketler
                      }
                    />
                    
                    <Field
                      name="islemNo"
                      label={t("davaIcraSavcilik.islemNo")}
                      colNumber="3"
                      component={TextInput}
                    />
                    
                    <Field
                      name="avukatID"
                      label={t("report.gorevlendirilen")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.users}
                    />
                    <Field
                      name="departmanID"
                      label={t("documentTypes.departman")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.departmanlar}
                      onChangeFunc={(opt) => onDepartmentChanged(opt)}
                    />
                    <Field
                      name="talepTuruID"
                      label={t("demandTypes.talepTürü")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={
                        talepTurleri.length > 0
                          ? talepTurleri
                          : configData && configData.talepTurleri
                      }
                      onChangeFunc={(opt) => onTalepChanged(opt)}
                    />
                    <Field
                      name="davaTuru"
                      label={t("demandCreate.davaTuru")}
                      colNumber="3"
                      component={MultiSelect}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.davaTurleri}
                    />
                    <Field
                      name="dosyaTuru"
                      label={t("davaIcraSavcilik.dosyaTuru")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={
                        dosyaTurleri.length > 0
                          ? dosyaTurleri.map((dt) => {
                              return { value: dt.id, label: dt.dosyaTuru };
                            })
                          : configData && configData.dosyaTurleri
                      }
                    />
                    <Field
                        name="dosyaDurumId"
                        label={t("demandList.dosyaDurumu")}
                        colNumber="3"
                        component={Select}
                        placeholder={t("formFields.allPlaceHolder")}
                        options={configData && configData.dosyaDurum}
                    />
                    <Field
                      name="konu"
                      label={t("davaIcraSavcilik.konu")}
                      colNumber="3"
                      component={TextInput}
                    />
                    {/* <Field
                      name="taraf1"
                      label={t("demandUpdate.taraf")}
                      colNumber="3"
                      component={TextInput}
                    /> */}
                    <Field
                      name="disAvukatID"
                      label={t("demandList.gorevliAvukat")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.disAvukatlar}
                    />
                    <Field
                      name="talepDurumuID"
                      label={t("demandStates.talepDurumu")}
                      colNumber="3"
                      component={MultiSelect}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.talepDurumu}
                    />

                    <Field
                      name="acilisTarihiMin"
                      label={t("report.talepatbas")}
                      colNumber="3"
                      component={ReactDatePicker}
                      onChangeFunc={(date) => {setStartDate(date)}}
                      maxDate={endDate}
                    />
                    <Field
                      name="acilisTarihiMax"
                      label={t("report.talepatbts")}
                      colNumber="3"
                      component={ReactDatePicker}
                      onChangeFunc={(date) => {setEndDate(date)}}
                      minDate={startDate}
                    />
                    <Field
                      name="kapanisTarihiMin"
                      label={t("report.talepktbas")}
                      colNumber="3"
                      component={ReactDatePicker}
                      onChangeFunc={(date) => {setClosedStartDate(date)}}
                      maxDate={closedEndDate}
                    />
                    <Field
                      name="kapanisTarihiMax"
                      label={t("report.talepktbts")}
                      colNumber="3"
                      component={ReactDatePicker}
                      onChangeFunc={(date) => {setClosedEndDate(date)}}
                      minDate={closedStartDate}
                    />

                    <Field
                      name="dilID"
                      label={t("sozlesmeler.dil")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.diller}
                    />
                    <Field
                      name="dovizID"
                      label={t("sozlesmeler.paraBirimi")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.paraBirimleri}
                    />
                    {<Field
                      name="fields"
                      label={t("report.listeAlanlari")}
                      colNumber="3"
                      component={MultiSelect}
                      onChangeFunc={(opt) => setFilteredColumns(opt)}
                      options={columns.map(c => {
                        return{
                          value: c.exportField,
                          label: c.text,
                        }
                      })}
                    />}
                    <Field
                      name="golgeNumarasiCheck"
                      label={t("report.golgeNumarasi")}
                      colNumber="3"
                      component={Checkbox}
                    />
                  </Filters>
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <ListComponent
            entityName=""
            endpoint="raporlar/listele"
            keyField="id"
            hideSelection
            refreshList={refreshList}
            customBody={{
              filters: getFilters()
            }}
            columns={filteredColumns}
            actionButtonsObject={{
              actions: [pushToParams(ABT.EXCEL_EXPORT,{
                requestTo: "file/download-excel-raporlamalar",
              } )],
              generator: DefaultActionButtonGenerator,
            }}
          />
        </div>
      </div>
    </Main>
  );
}

export default OtherReports;
